(function () {
  'use strict';

  const { iman } = window.Universe;


  class ImageComparison {
    constructor(container) {
      this.init(container || document);
    }

    init(container) {
      container = container || document;
      let wrap = container;
      if (!(wrap instanceof Element) || !wrap.classList.contains('js-then-now')) {
        wrap = container.querySelector('.js-then-now');
      }

      if (wrap) {
        this.DOM = {
          wrap: wrap,
          button: wrap.querySelector('.comparison__button'),
        };
        this.sectionId = wrap.closest('.shopify-section')?.id || null;

        this.startHandler = () => {
          this.active = true;
          this.DOM.wrap.classList.add('scrolling');
        };

        this.endHandler = () => {
          this.active = false;
          this.DOM.wrap.classList.remove('scrolling');
        };

        this.onHandler = (e) => {
          if (!this.active) return;

          const event = (e.touches && e.touches[0]) || e;
          const horizontal = this.DOM.wrap.getAttribute('data-layout') === 'horizontal';
          const x = horizontal
            ? event.pageX - (this.bounding.left + window.scrollX)
            : event.pageY - (this.bounding.top + window.scrollY);

          this.scrollIt(x);
        };

        this.setup();
      }
    }

    setup() {
      this.active = false;

      if (this.button) {
        this.button.addEventListener('touchstart', this.startHandler, false);
        document.body.addEventListener('touchend', this.endHandler, false);
        document.body.addEventListener('touchmove', this.onHandler, false);

        this.button.addEventListener('mousedown', this.startHandler);
        document.body.addEventListener('mouseup', this.endHandler);
        document.body.addEventListener('mousemove', this.onHandler);
      }
    }

    scrollIt(x) {
      const horizontal = this.DOM.wrap.getAttribute('data-layout') === 'horizontal';
      const distance = horizontal ? this.DOM.wrap.clientWidth : this.DOM.wrap.clientHeight;

      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;
      this.DOM.wrap.style.setProperty('--percent', mousePercent + '%');
    }

    destroy() {
      if (this.DOM && this.button) {
        this.button.removeEventListener('touchstart', this.startHandler);
        document.body.removeEventListener('touchend', this.endHandler);
        document.body.removeEventListener('touchmove', this.onHandler);

        this.button.removeEventListener('mousedown', this.startHandler);
        document.body.removeEventListener('mouseup', this.endHandler);
        document.body.removeEventListener('mousemove', this.onHandler);

        this.DOM = undefined;
      }
    }
  }

  Object.defineProperty(ImageComparison.prototype, 'button', {
    get: function () {
      return this.DOM.button;
    },
  });

  Object.defineProperty(ImageComparison.prototype, 'bounding', {
    get: function () {
      return this.DOM.wrap.getBoundingClientRect();
    },
  });

  Object.defineProperty(ImageComparison.prototype, 'horizontal', {
    get: function () {
      return this.DOM.wrap.getAttribute('data-layout') === 'horizontal';
    },
  });

  Object.defineProperty(ImageComparison.prototype, 'media', {
    get: function () {
      return Array.from(this.DOM.wrap.querySelectorAll('img, svg'));
    },
  });


  class ThenVsNow {
    constructor() {
      this.init();
    }

    setup() {
      for (let i = 0; i < this.DOM.sections.length; i++) {
        this.comparisons.push(new ImageComparison(this.DOM.sections[i]));
      }
    }

    reinit() {
      this.destroy();
      this.init();
    }

    reinitSection(sectionEl) {
      this.destroySection(sectionEl);

      if (!this.DOM) {
        this.DOM = {};
        this.comparisons = [];
      }

      const newSections = sectionEl.querySelectorAll('.js-then-now');
      for (let i = 0; i < newSections.length; i++) {
        const instance = new ImageComparison(newSections[i]);
        if (instance.DOM) this.comparisons.push(instance);
      }

      this.DOM.sections = document.querySelectorAll('.js-then-now');
    }

    destroySection(sectionEl) {
      if (!this.comparisons) return;

      const targetId = sectionEl.id || sectionEl.closest('.shopify-section')?.id;
      if (!targetId) return;

      for (let i = this.comparisons.length - 1; i >= 0; i--) {
        const instance = this.comparisons[i];
        if (instance.sectionId === targetId) {
          instance.destroy();
          this.comparisons.splice(i, 1);
        }
      }
    }

    destroy() {
      if (this.DOM) {
        for (let i = 0; i < this.comparisons.length; i++) {
          this.comparisons[i].destroy();
        }
        this.comparisons = [];
        this.DOM = undefined;
      }
    }

    init(container) {
      container = container || document;
      const sections = container.querySelectorAll('.js-then-now');
      if (sections.length) {
        this.DOM = {};
        this.DOM.sections = sections;
        this.comparisons = [];
        this.setup();
      }
    }
  }

  function init() {
    if (!iman.get('thenVsNow')) {
      iman.add('thenVsNow', new ThenVsNow());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Universe.ThenVsNow = ThenVsNow;
  window.Universe.ImageComparison = ImageComparison;
})();
